export default {
  id: null,
  country_code: "",
  in_date: "",
  out_date: "",
  breakfast_count: "0",
  lunch_count: "0",
  dinner_count: "0",
  currency: "",
  delegation_rate: null,
  amount: null,
  accommodation: [],
  region: ""
};
